import { createContext, useContext, useState } from 'react';

const AuthenticationContext = createContext();

export function useAuthenticationContext() {
  return useContext(AuthenticationContext);
}

export function AuthenticationContextProvider({ children }) {
  const [userId, setUserId] = useState(null);

  const value = {
    userId,
    setUserId,
  };

  return <AuthenticationContext.Provider value={value}>{children}</AuthenticationContext.Provider>;
}
